import {
  Callout,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  DirectionalHint,
  Fabric,
  IColumn,
  IDetailsListProps,
  IDetailsRowStyles,
  IStackTokens,
  ITag,
  PrimaryButton,
  SelectionMode,
  Stack,
  Text,
  TooltipHost,
} from "office-ui-fabric-react";
import React from "react";
import { Loading } from "../../../services/Loading";
import { ICustomerEventSource, IEventSource } from "../../../vm";
import { useParams } from "react-router-dom";
import NoDataTile from "../../common/NoDataTile";
import Icon from "@mdi/react";
import { mdiDotsVertical, mdiPencilOutline, mdiTrashCanOutline } from "@mdi/js";
import { THEME, BRAND_SECONDARY } from "../../../utils/Styles";
import {
  deleteCustomerEventSources,
  getCustomerEventSources,
} from "../../../services/customers/CustomerService";
import { ToastContext } from "../../common/ToastProvider";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import { getAllDataCentersOfCustomer } from "../../../services/datacenter/DatacenterService";
import ManageEventSourceDialog from "./ManageEventSourceDialog";
import { childrenGap, childrenGap8 } from "../../common/Constants";
import { parseJwt } from "../../../services/UtilService";

export interface EventSourcesProps { }

const EventSources: React.FC<EventSourcesProps> = () => {
  //state
  const [state, setState] = React.useState({
    isLoading: false,
    // isEventSourceFound: false,
    customerEventSources: [],
    manageEsDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    dataCenterList: [],
    manageActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
  } as {
    isLoading: boolean;
    // isEventSourceFound: boolean;
    customerEventSources: ICustomerEventSource[];
    manageEsDialog: {
      isOpen: boolean;
      index?: number;
      data?: ICustomerEventSource;
    };
    dataCenterList: ITag[];
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: ICustomerEventSource;
    };
  });

  //custom hooks
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);
  const tokenData = parseJwt();

  const childrenGap24: IStackTokens = { childrenGap: 24 };

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getAllCustomerEventSource();
    };
    asyncFunc();
  }, []);

  const getAllCustomerEventSource = async () => {
    setState({ ...state, isLoading: true });
    let result = await getCustomerEventSources({
      customerId: params.customerId,
    });
    if (result?.success) {
      getDataCenters(result.data);
      // setState({
      //   ...state,
      //   customerEventSources: result.data,
      //   isLoading: false,
      //   isEventSourceFound: true,
      // });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting event sources config",
        "error"
      );
    }
  };

  const getDataCenters = async (data: ICustomerEventSource[]) => {
    setState({ ...state, isLoading: true });
    let result = await getAllDataCentersOfCustomer(params.customerId);
    if (result?.success) {
      let dataCenterList: ITag[] = [];

      result.data.forEach((item) => {
        dataCenterList.push({
          key: item._id as string,
          name: item.name,
        });
      });

      setState({
        ...state,
        customerEventSources: data,
        // isEventSourceFound: true,
        isLoading: false,
        dataCenterList,
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(result.message || "Error while getting datacenter", "error");
    }
  };

  const handleDialogOpen = (isOpen: boolean, index?: number) => {
    let customerEventSources = undefined;
    if (index !== undefined) {
      customerEventSources = { ...state.customerEventSources[index] };
    }
    setState({
      ...state,
      manageEsDialog: {
        isOpen: isOpen,
        index: index,
        data: customerEventSources,
      },
    });
  };

  const handleDialogClose = (data: ICustomerEventSource) => {
    let customerEventSources = [...state.customerEventSources];
    if (data) {
      if (state.manageEsDialog.index !== undefined) {
        customerEventSources[state.manageEsDialog.index] = data;
        showToast("Event source config updated successfully", "success");
      } else {
        customerEventSources.unshift(data);
        showToast("Event source config added successfully", "success");
      }
    }
    setState({
      ...state,
      manageEsDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      customerEventSources,
    });
  };

  const deleteEs = async (item: ICustomerEventSource, index: number) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete event source config",
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let result = await deleteCustomerEventSources(item);
        if (result?.success) {
          showToast("Event source config deleted successfully", "success");
          let customerEventSources = [...state.customerEventSources];
          customerEventSources.splice(index, 1);
          setState({
            ...state,
            customerEventSources,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(
            result.message || "Error while deleting event source config",
            "error"
          );
        }
      }
    );
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <span
            onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
          >
            <Icon
              path={mdiDotsVertical}
              size={0.9}
              className="pointer"
              color={BRAND_SECONDARY}
            />
          </span>
          // <Stack horizontal>
          //   <TooltipHost
          //     content="Edit Event Source"
          //     id={`editEs`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => handleDialogOpen(true, index)}>
          //       <Icon
          //         path={mdiPencilOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          //   &nbsp;&nbsp;
          //   <TooltipHost
          //     content="Delete Event Source"
          //     id={`deleteEs`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => deleteEs(item, index)}>
          //       <Icon
          //         path={mdiTrashCanOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.themePrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          // </Stack>
        );
      case "datacenterName":
        return (
          <Text style={{ fontWeight: 600 }}>
            {
              state.dataCenterList.find((ele) => ele.key === item.datacenterId)
                ?.name
            }
          </Text>
        );
      case "eventSources": {
        return (
          <Stack horizontal wrap tokens={childrenGap8}>
            {item.eventSources.map((eventSource: any, index: number) => (
              <Stack.Item key={index} className="chips">
                <span>{eventSource?.name || ""}</span>
              </Stack.Item>
            ))}
          </Stack>
        );
      }
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: ICustomerEventSource
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack className="pt-16" tokens={childrenGap}>
        {![2, 4, 5].includes(tokenData.role) && (
          <Stack.Item align="end">
            <PrimaryButton
              text="Add Event Source"
              onClick={() => handleDialogOpen(true)}
              className="borderless-btn bg-white"
            />
          </Stack.Item>
        )}
        <Stack.Item>
          <div>
            {state.customerEventSources &&
              state.customerEventSources.length > 0 ? (
              <Fabric>
                <DetailsList
                  items={state.customerEventSources}
                  columns={
                    ![2, 4, 5].includes(tokenData.role)
                      ? [
                        {
                          key: "datacenterName",
                          name: "Datacenter Name",
                          fieldName: "datacenterName",
                          minWidth: 200,
                          maxWidth: 300,
                          isResizable: true,
                        },
                        {
                          key: "eventSources",
                          name: "Event Sources",
                          fieldName: "eventSources",
                          minWidth: 500,
                          maxWidth: 700,
                          isResizable: true,
                        },
                        {
                          key: "actions",
                          name: "Actions",
                          fieldName: "actions",
                          minWidth: 200,
                          maxWidth: 300,
                          isResizable: true,
                        },
                      ]
                      : [
                        {
                          key: "datacenterName",
                          name: "Datacenter Name",
                          fieldName: "datacenterName",
                          minWidth: 200,
                          maxWidth: 300,
                          isResizable: true,
                        },
                        {
                          key: "eventSources",
                          name: "Event Sources",
                          fieldName: "eventSources",
                          minWidth: 500,
                          maxWidth: 700,
                          isResizable: true,
                        },
                      ]
                  }
                  compact={true}
                  setKey="set"
                  onRenderItemColumn={_renderItemColumn as any}
                  layoutMode={DetailsListLayoutMode.justified}
                  selectionMode={SelectionMode.none}
                  onRenderRow={_onRenderRow}
                />
              </Fabric>
            ) : (
              <NoDataTile title="No Event Sources Found for this Customer"></NoDataTile>
            )}
          </div>
        </Stack.Item>
      </Stack>
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleDialogOpen(true, state.manageActionsCallout.index);
                }}
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  deleteEs(
                    state.manageActionsCallout.data as ICustomerEventSource,
                    state.manageActionsCallout.index as number
                  );
                }}
                className="callout-options"
              >
                Delete
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {state.manageEsDialog.isOpen && (
        <ManageEventSourceDialog
          data={state.manageEsDialog.data}
          handleLoading={handleLoading}
          customerId={params.customerId}
          handleDialogClose={(data: ICustomerEventSource) =>
            handleDialogClose(data)
          }
          customerEventSources={state.customerEventSources}
          dataCenterList={state.dataCenterList}
        />
      )}
    </React.Fragment>
  );
};

export default EventSources;
